(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (!window.Plyr) return;
    document.querySelectorAll('[data-tp]').forEach(init);
  });

  function init(root) {
    var stage = root.querySelector('[data-tp-stage]');
    var videoEl = root.querySelector('[data-tp-video]');
    var cards = root.querySelectorAll('[data-tp-open]');
    var thumbs = root.querySelectorAll('[data-tp-thumb]');
    var pip = root.querySelector('[data-tp-pip]');
    var pipVideo = pip && pip.querySelector('video');
    var closeBtn = root.querySelector('[data-tp-close]');
    var muteBtn = root.querySelector('[data-tp-mute]');
    var shareBtn = root.querySelector('[data-tp-share]');
    var rail = root.querySelector('[data-tp-track]');
    var prev = root.querySelector('[data-tp-prev]');
    var next = root.querySelector('[data-tp-next]');
    var qty = root.querySelector('[data-tp-qty]');
    var qtyVal = root.querySelector('[data-tp-qty-val]');
    var sources = [];
    var orients = [];
    cards.forEach(function (c) {
      sources.push(c.getAttribute('data-src'));
      orients.push(c.getAttribute('data-orient') || 'portrait');
    });
    var stageVideo = root.querySelector('.tp-main__video');

    var isEmbed = root.classList.contains('tp--embed');
    var player = new Plyr(videoEl, {
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
      hideControls: false,
      autoplay: false,
      ratio: '9:16',
      fullscreen: { enabled: true, fallback: true, iosNative: true },
      iconUrl: 'https://cdn.plyr.io/3.7.8/plyr.svg'
    });
    var lockedY = 0;

    var index = 0;
    function load(i) {
      index = (i + sources.length) % sources.length;
      var land = orients[index] === 'landscape';
      if (stageVideo) stageVideo.classList.toggle('is-land', land);
      player.ratio = land ? '16:9' : '9:16';
      player.source = { type: 'video', sources: [{ src: sources[index], type: 'video/mp4' }] };
      thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === index); });
      player.play();
    }

    function open(i) {
      lockedY = window.scrollY || window.pageYOffset;
      document.body.appendChild(stage);
      stage.classList.add('is-on');
      document.documentElement.classList.add('tp-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      load(i);
      if (pip) pip.classList.remove('is-on');
    }
    function close() {
      stage.classList.remove('is-on');
      if (stage.parentNode !== root) root.appendChild(stage);
      document.documentElement.classList.remove('tp-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      window.scrollTo(0, lockedY);
      player.pause();
    }

    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { open(i); });
    });
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { load(i); });
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (!stage.classList.contains('is-on')) return;
      var tag = (e.target && e.target.tagName) || '';
      if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') return;
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        load(index + 1);
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        load(index - 1);
      } else if (e.key === 'm' || e.key === 'M') {
        player.muted = !player.muted;
      } else if (e.key === ' ') {
        e.preventDefault();
        player.togglePlay();
      }
    });
    if (muteBtn) muteBtn.addEventListener('click', function () { player.muted = !player.muted; });
    if (shareBtn) shareBtn.addEventListener('click', function () {
      var url = window.location.href;
      if (navigator.share) navigator.share({ url: url }).catch(function () {});
      else navigator.clipboard.writeText(url);
    });
    if (prev && rail) prev.addEventListener('click', function () { rail.scrollBy({ left: -280, behavior: 'smooth' }); });
    if (next && rail) next.addEventListener('click', function () { rail.scrollBy({ left: 280, behavior: 'smooth' }); });
    root.querySelectorAll('[data-tp-qty]').forEach(function (row) {
      row.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var input = row.querySelector('[data-tp-qty-val]');
        if (!input) return;
        var n = parseInt(input.value, 10) || 1;
        if (b.getAttribute('data-d') === '-') n = Math.max(1, n - 1);
        else n += 1;
        input.value = n;
      });
    });
    root.querySelectorAll('[data-tp-plans]').forEach(function (box) {
      var selling = box.querySelector('[data-tp-selling]');
      var planSel = box.querySelector('[data-tp-plan-select]');
      function sync() {
        var sub = box.querySelector('[data-tp-opt][value="sub"]');
        var once = box.querySelector('[data-tp-opt][value="once"]');
        var isSub = sub && sub.checked;
        if (selling) selling.value = isSub && planSel ? planSel.value : '';
        box.querySelectorAll('.tp-buy__opt').forEach(function (lab) {
          lab.classList.toggle('is-on', lab.querySelector('[data-tp-opt]').checked);
        });
      }
      box.addEventListener('change', sync);
      sync();
    });
    root.querySelectorAll('[data-tp-variant]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        var panel = sel.closest('[data-tp-panel]');
        if (!panel) return;
        var once = panel.querySelector('[data-tp-once-price]');
        var sub = panel.querySelector('[data-tp-sub-price]');
        if (once && opt.getAttribute('data-price')) once.textContent = opt.getAttribute('data-price');
        if (sub && opt.getAttribute('data-sub')) sub.textContent = opt.getAttribute('data-sub');
        var price = panel.querySelector('.price');
        if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
      });
    });
    function shopRoot() {
      return stage.querySelector('[data-tp-shop]') || root;
    }
    shopRoot().querySelectorAll('[data-tp-swap]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var h = btn.getAttribute('data-tp-swap');
        shopRoot().querySelectorAll('[data-tp-panel]').forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-tp-panel') !== h;
        });
        shopRoot().querySelectorAll('[data-tp-swap]').forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
        });
      });
    });

    if (pip) pip.classList.remove('is-on');
    if (pip && pipVideo && 'IntersectionObserver' in window && !isEmbed) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting && !stage.classList.contains('is-on')) {
            pipVideo.src = sources[0];
            pip.classList.add('is-on');
            pipVideo.muted = true;
            pipVideo.play().catch(function () {});
          } else {
            pip.classList.remove('is-on');
            pipVideo.pause();
          }
        });
      }, { threshold: 0.05 });
      io.observe(root.querySelector('[data-tp-rail]') || root);
      var pipClose = pip.querySelector('button');
      if (pipClose) pipClose.addEventListener('click', function () {
        pip.classList.remove('is-on');
        pipVideo.pause();
      });
    }
  }
})();
